import React from 'react';
import Icon from '3-components/Icon/Icon';

interface ChipProps {
    chipTitle: string;
    chipIcon?: string;
    chipUrl?: string;
}

const Chip = ({ chipTitle, chipIcon, chipUrl }: ChipProps) => {
    if (chipUrl) {
        return (
            <a href={chipUrl} className="chip-component chip-link">
                {chipIcon && <Icon icon={chipIcon} className="chip-icon" />}
                <span className="chip-title">{chipTitle}</span>
            </a>
        );
    }

    return (
        <div className="chip-component">
            {chipIcon && <Icon icon={chipIcon} className="chip-icon" />}
            <span className="chip-title">{chipTitle}</span>
        </div>
    );
};

export default Chip;
